import React from 'react';
import { __ } from '@wordpress/i18n';

// store
import { useStoreValue } from '../../store';

// components
import SoccorsiInstructorManagerMioTableAsync from './components/SoccorsiInstructorManagerMioTableAsync';

const SoccorsoIstruttorioMioInstructorManager = () => {
    const userData = useStoreValue('userData');

    return(
        <div className="appPage">
            <div className="appPage__pageHeader">
                <h1>{__('Soccorso istruttorio', 'gepafin')}</h1>
            </div>

            <div className="appPage__spacer"></div>

            <div className="appPageSection">
                <SoccorsiInstructorManagerMioTableAsync userId={userData.id}/>
            </div>
        </div>
    )
}

export default SoccorsoIstruttorioMioInstructorManager;